export const GFM_POPOVER_SELECTOR =
  '.gfm-issue, .gfm-work_item, .gfm-merge_request, .gfm-epic, .gfm-milestone, .gfm-commit';

export const unrestrictedPages = [
  // Group wiki
  'groups:wikis:show',
  'groups:wikis:edit',
  'groups:wikis:create',

  // Project wiki
  'projects:wikis:show',
  'projects:wikis:edit',
  'projects:wikis:create',

  // Project files
  'projects:show',
  'projects:blob:show',
];
